import React from 'react';
import AnimatedSection from './AnimatedSection';
import { getCortexEventBySlug } from '../../config/cortexEvents';

const CortexAbstracts2026Publication = ({ sectionId = 'publications' }) => {
    const abstracts2026 = getCortexEventBySlug('abstracts-2026');
    if (!abstracts2026) return null;

    return (
        <AnimatedSection
            id={sectionId}
            className="mb-16"
            heading={<h2 className="text-3xl font-semibold text-gray-900 mb-8">Publications</h2>}
        >
            <div className="bg-white rounded-lg shadow-md p-8">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Conference Materials</h3>
                <div className="grid md:grid-cols-2 gap-6">
                    <div className="p-4 border rounded-lg">
                        <a
                            href={abstracts2026.zenodoUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block w-full bg-gray-100 rounded-md overflow-hidden mb-3 group relative cursor-pointer"
                        >
                            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 z-10"></div>
                            <img
                                src={encodeURI(abstracts2026.coverImage)}
                                alt="CORTEX 2026 Book of Abstracts cover"
                                className="w-full h-auto object-contain group-hover:scale-110 transition-transform duration-300"
                                loading="lazy"
                            />
                        </a>
                        <h4 className="font-semibold text-gray-900 mb-1.5">Book of Abstracts</h4>
                        <p className="text-gray-600 text-sm mb-4">{abstracts2026.shortDescription}</p>
                        <div className="flex gap-2">
                            <a
                                href={abstracts2026.zenodoUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex-1 px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-semibold hover:border-blue-400 hover:text-blue-600 transition text-center"
                            >
                                Read on Zenodo
                            </a>
                            <a
                                href={encodeURI(abstracts2026.pdfPath)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex-1 px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-semibold hover:border-orange-400 hover:text-orange-600 transition text-center"
                            >
                                Download PDF
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </AnimatedSection>
    );
};

export default CortexAbstracts2026Publication;
